

import CampaignMetricsPartial from "../../partials/campaign/campaign-metircs.partial";

export default function CampaignMetricsScreen() {
  return <CampaignMetricsPartial />;
}
